import { type LucideIcon, PrinterIcon, SmartphoneIcon } from 'lucide-react';

import { Icon, Tooltip } from '@/_components';

type InvoicePdfActionsCellProps = {
  printableUrl?: string | null;
  digitalUrl?: string | null;
};

function PdfIconLink({ href, label, icon: IconComponent }: { href?: string | null; label: string; icon: LucideIcon }) {
  const url = href?.trim();
  if (!url) {
    return (
      <span className="text-c-card-muted inline-flex size-8 items-center justify-center opacity-30" aria-hidden>
        <Icon icon={IconComponent} className="size-4" />
      </span>
    );
  }

  return (
    <Tooltip content={label} placement="top" zIndex={50}>
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="text-c-card-muted hover:text-c-foreground inline-flex size-8 items-center justify-center rounded-md hover:bg-gray-100 dark:hover:bg-gray-800"
        aria-label={label}
        onClick={(e) => e.stopPropagation()}
      >
        <Icon icon={IconComponent} className="size-4" />
      </a>
    </Tooltip>
  );
}

/** Printable (remittance) + digital invoice PDF links for list tables. */
export function InvoicePdfActionsCell({ printableUrl, digitalUrl }: InvoicePdfActionsCellProps) {
  return (
    <div className="flex items-center justify-center gap-0.5">
      <PdfIconLink href={printableUrl} label="Printable PDF (remittance)" icon={PrinterIcon} />
      <PdfIconLink href={digitalUrl} label="Digital PDF" icon={SmartphoneIcon} />
    </div>
  );
}
